import {useSessionStorage} from 'react-use';
import {sendAnalyticPayload, AnalyticEvent} from '../utils/analytic';
import {ANONYMOUS_ID_NAMESPACE} from '../ev-ampol-amp-charge/constants';
import {useAnonymousId} from './useAnonymousId';

export const useSendAmpChargeAnalytic = () => {
  const [value] = useSessionStorage<string>(ANONYMOUS_ID_NAMESPACE);
  const {anonymousId} = useAnonymousId();

  const handleViewInARClick = () => {
    sendAnalyticPayload(
      {
        process: {
          Name: 'EV Charger',
          StepName: 'View in AR',
          StepNumber: '',
        },
        link: {
          name: 'View in AR',
        },
        context: {
          ...(value && {ExternalAnonymousId: value}),
          AnonymousId: anonymousId,
        },
      },
      AnalyticEvent.CTAClick,
    );
  };

  const handleContinueIntroClick = () => {
    sendAnalyticPayload(
      {
        process: {
          Name: 'EV Charger',
          StepName: 'Continue',
          StepNumber: '',
        },
        link: {
          name: 'Continue',
        },
        context: {
          ...(value && {ExternalAnonymousId: value}),
          AnonymousId: anonymousId,
        },
      },
      AnalyticEvent.CTAClick,
    );
  };

  const handleSkipWalkThroughClick = () => {
    sendAnalyticPayload(
      {
        process: {
          Name: 'EV Charger',
          StepName: 'Skip',
          StepNumber: '',
        },
        link: {
          name: 'Skip',
        },
        context: {
          ...(value && {ExternalAnonymousId: value}),
          AnonymousId: anonymousId,
        },
      },
      AnalyticEvent.CTAClick,
    );
  };

  const handleViewChargerDeviceInARClick = (chargerName: string) => {
    sendAnalyticPayload(
      {
        process: {
          Name: 'EV Charger',
          StepName: `Choose charger - ${chargerName}`,
          StepNumber: '',
        },
        link: {
          name: 'Choose charger',
        },
        context: {
          ...(value && {ExternalAnonymousId: value}),
          AnonymousId: anonymousId,
        },
      },
      AnalyticEvent.CTAClick,
    );
  };

  const handleFinalStepCTAClick = (ctaName: string) => {
    sendAnalyticPayload(
      {
        process: {
          Name: 'EV Charger',
          StepName: ctaName,
          StepNumber: '',
        },
        link: {
          name: ctaName,
        },
        context: {
          ...(value && {ExternalAnonymousId: value}),
          AnonymousId: anonymousId,
        },
      },
      AnalyticEvent.CTAClick,
    );
  };

  return {
    handleViewInARClick,
    handleContinueIntroClick,
    handleSkipWalkThroughClick,
    handleViewChargerDeviceInARClick,
    handleFinalStepCTAClick,
  };
};
